export const appHead = {"meta":[{"charset":"utf-8"},{"name":"charset","content":"UTF-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=no, interactive-widget=resizes-content, viewport-fit=cover"},{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"name":"author","content":"비바라비다"},{"name":"publisher","content":"비바라비다"},{"name":"description","content":"오직 4060을 위해 만들어진 취미 모임 플랫폼! 오이로 다양한 취미 활동 함께해요"},{"name":"keywords","content":"취미모임, 소셜모임, 소모임, 문화모임, 동네모임, 매너모임, 동네친구, 동호회, 4060"},{"name":"robots","content":"index, follow"},{"property":"og:type","content":"website"},{"property":"og:title","content":"취미로 꽃 피우다."},{"property":"og:description","content":"4060 모임 커뮤니티"},{"property":"og:site_name","content":"오이"},{"property":"og:image","content":"https://oe-app.com/images/og-image.png"},{"name":"facebook-domain-verification","content":"97psgu8nz7co4rao4ieqltre8l117m"}],"link":[],"style":[{"textContent":"html { -webkit-text-size-adjust: 100%; }"}],"script":[{"src":"/script/meta-pixel.js"},{"innerHTML":"(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n          })(window,document,'script','dataLayer','GTM-KBJ4QW9F');"},{"src":"https://wcs.naver.net/wcslog.js"},{"innerHTML":"if (!window.wcs_add) var wcs_add = {};\n          wcs_add[\"wa\"] = \"s_29913ae870\";\n          if (!window._nasa) var _nasa = {};\n          if (window.wcs) {\n            wcs.inflow();\n            wcs_do();\n          }"}],"noscript":[{"innerHTML":"<iframe src=\"https://www.googletagmanager.com/ns.html?id=GTM-KBJ4QW9F\"\n          height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>"}],"charset":"utf-8","title":"오이 | 따분한 일상이 바뀌는 순간","htmlAttrs":{"lang":"ko"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false